import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { StaticPageHeader } from 'src/domains/players/webview/components/Account/staticPage/StaticPageHeader';
import {
    StaticPageInnerWrapper,
    StaticPageWrapper,
    StaticPageInfoWrapper,
    StaticPageLoaderWrapper,
} from 'src/domains/players/webview/components/Account/staticPage/StaticPage.style';
import { HeadlineCarouselState } from 'src/domains/layouts/state/cmsState/headlineCarouselState/HeadlineCarouselState';
import { CarouselModeType } from 'src/domains/layouts/state/cmsState/homePageCarouselState/HomePageCarouselState';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
interface PropsType {
    promoId: string;
}

const getCarouselMode = (routeName: string): CarouselModeType => {
    if (routeName === 'homepage') {
        return 'homepage';
    }
    if (routeName === 'casino') {
        return 'casino';
    }
    if (routeName === 'virtuals') {
        return 'virtuals';
    }
    if (routeName === 'live-casino') {
        return 'live-casino';
    }

    return 'homepage';
};

export const StaticResourceHeadlineCarouselTerms = observer(
    'StaticResourceHeadlineCarouselTerms',
    ({ promoId }: PropsType): React.ReactElement | null => {
        const common = useCommon();
        const starRouter = StarRouter.get(common);
        const routeName = starRouter.currentView?.name ?? '';
        const route = getCarouselMode(routeName);
        const [headlineCarouselState] = useState(() => new HeadlineCarouselState(route));
        const terms = headlineCarouselState.getActiveTerms(promoId);

        if (terms === null) {
            return (
                <StaticPageWrapper>
                    <StaticPageHeader
                        title={
                            <I18n
                                langKey='account.static-page.error.title'
                                defaultText='Error occurred'
                            />
                        }
                        back={true}
                        parent='summary'
                    />
                    <StaticPageInnerWrapper>
                        <StaticPageInfoWrapper>
                            <I18n
                                langKey='account.static-page.error.description'
                                defaultText="Sorry, we can't find page you are searching for."
                            />
                        </StaticPageInfoWrapper>
                    </StaticPageInnerWrapper>
                </StaticPageWrapper>
            );
        }
        const headlinePageCarouselResourceType = headlineCarouselState.headlineCarouselDataTyoe;

        if (headlinePageCarouselResourceType === 'loading') {
            return <StaticPageLoaderWrapper />;
        }

        if (headlinePageCarouselResourceType === 'error') {
            return (
                <StaticPageWrapper>
                    <StaticPageHeader
                        title={
                            <I18n
                                langKey='account.static-page.error.title'
                                defaultText='Error occurred'
                            />
                        }
                        back={true}
                        parent='summary'
                    />
                    <StaticPageInnerWrapper>
                        <StaticPageInfoWrapper>
                            <I18n
                                langKey='account.static-page.error.description'
                                defaultText="Sorry, we can't find page you are searching for."
                            />
                        </StaticPageInfoWrapper>
                    </StaticPageInnerWrapper>
                </StaticPageWrapper>
            );
        }

        return (
            <StaticPageWrapper>
                <StaticPageHeader
                    title={
                        <I18n
                            langKey='static-page.header.terms-and-conditions'
                            defaultText='Terms And Conditions'
                        />
                    }
                    back={true}
                    parent='home'
                />
                <StaticPageInnerWrapper>
                    <div dangerouslySetInnerHTML={{ __html: terms }} />
                </StaticPageInnerWrapper>
            </StaticPageWrapper>
        );
    }
);
